import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import fontFaceName from "./font-face-name";

export default function MonogramStepFont({
  product,
  globalConfig,
  config,
  setConfig,
  setVisible,
}) {
  const availableFonts =
    product.monogramSettings.fontOptions || globalConfig.defaultFonts;

  const update = (fontId) => {
    const font = availableFonts.find(({ id }) => fontId === id);
    setConfig({ ...config, font });
  };

  const handleChange = (e) => {
    update(e.target.value);
  };

  if (!config.font) {
    update(availableFonts[0].id);
  }

  if (availableFonts.length < 2) {
    setVisible(false);
    return null;
  }

  setVisible(true);

  return (
    <div className="monogram-config__fonts">
      {availableFonts.map((font) => (
        <label className="monogram-config__font-label monogram-config__radio-label">
          <input
            className="monogram-config__font-input monogram-config__radio-input"
            type="radio"
            name="monogram-font"
            checked={config.font?.id === font.id}
            onChange={handleChange}
            value={font.id}
          />
          <div class="monogram-config__font-value">
            <div className="monogram-config__font-name">{font.name}</div>
            <div
              className={`monogram-config__font-preview ${font.hasShadow === "true" ? "monogram-config__font-preview--shadow" : ""}`}
              style={{
                fontFamily: fontFaceName(font.name),
                fontSize: `${(parseFloat(font.previewScale) * 12) / 100}px`,
              }}
            >
              {font.preview || "ABCDE"}
            </div>
          </div>
        </label>
      ))}
    </div>
  );
}
